import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { emptyFn } from '../../utils/helper';
import { MenuItemContext } from './context';
import Keep from '../Dropdown/Keep';
import { consumeTheme } from '../../utils/theme';
import Dropdown from '../Dropdown';
var Item = (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        _this.state = {
            actionActive: false,
        };
        _this.refDom = function (dom) {
            _this.domRef.current = dom;
            var propRef = _this.props.domRef;
            var selectedItemDoms = _this.context.selectedItemDoms;
            if (_this.isSelected()) {
                selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.add(dom);
            }
            else {
                selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.delete(dom);
            }
            if (!propRef) {
                return;
            }
            if (typeof propRef === 'function') {
                propRef(dom);
            }
            else {
                propRef.current = dom;
            }
        };
        _this.handleClick = function (e) {
            var _a;
            var clickHandler = _this.context.clickHandler;
            var _b = _this.props, disabled = _b.disabled, onClick = _b.onClick;
            if (e.detail) {
                (_a = _this.domRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
            if (disabled || e.nativeEvent._dui_menu_item_action) {
                return;
            }
            var result = onClick(e);
            if (result === false) {
                return;
            }
            if (!e.isPropagationStopped()) {
                clickHandler(_this.props.id);
            }
        };
        _this.handleKeyDown = function (e) {
            var _a;
            var _b = _this.props, disabled = _b.disabled, onKeyDown = _b.onKeyDown;
            if (disabled) {
                return;
            }
            var result = onKeyDown(e);
            if (result === false) {
                return;
            }
            if ([' ', 'Enter'].includes(e.key)) {
                e.preventDefault();
                (_a = _this.domRef.current) === null || _a === void 0 ? void 0 : _a.click();
            }
        };
        _this.handleActionClick = function (e) {
            e.nativeEvent._dui_menu_item_action = true;
        };
        _this.handleToggleAction = function (actionActive) {
            _this.setState({ actionActive: actionActive });
        };
        _this.handleMouseEnter = function (e) {
            var _a = _this.props, disabled = _a.disabled, onMouseEnter = _a.onMouseEnter;
            if (disabled) {
                return;
            }
            onMouseEnter(e);
        };
        _this.handleMouseLeave = function (e) {
            var _a = _this.props, disabled = _a.disabled, onMouseLeave = _a.onMouseLeave;
            if (disabled) {
                return;
            }
            onMouseLeave(e);
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, disabled = _b.disabled, description = _b.description, htmlId = _b.htmlId, containerClassName = _b.containerClassName, containerStyle = _b.containerStyle, testId = _b.testId, action = _b.action, id = _b.id, children = _b.children, icon = _b.icon, onClick = _b.onClick, onKeyDown = _b.onKeyDown, propSelected = _b.selected, domRef = _b.domRef, actionTriggersDropdownHide = _b.actionTriggersDropdownHide, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave, actionAutoFocus = _b.actionAutoFocus, rest = __rest(_b, ["prefixCls", "className", "style", "disabled", "description", "htmlId", "containerClassName", "containerStyle", "testId", "action", "id", "children", "icon", "onClick", "onKeyDown", "selected", "domRef", "actionTriggersDropdownHide", "onMouseEnter", "onMouseLeave", "actionAutoFocus"]);
            var actionActive = _this.state.actionActive;
            var _c = _this.context, itemStyle = _c.itemStyle, itemClassName = _c.itemClassName;
            var selected = _this.isSelected();
            var cls = classNames(prefixCls, className, itemClassName, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a[prefixCls + "-selected"] = selected,
                _a[prefixCls + "-with-action"] = action,
                _a[prefixCls + "-with-action-active"] = actionActive,
                _a));
            var containerCls = classNames(prefixCls + "-container", containerClassName);
            return (h(Keep, { disabled: !disabled, className: containerCls, style: containerStyle },
                h("li", __assign({ className: cls, style: __assign(__assign({}, itemStyle), style), onClick: _this.handleClick, ref: _this.refDom, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave, role: "menuitem", "aria-disabled": disabled, "aria-checked": selected, tabIndex: disabled ? -1 : 0, onKeyDown: _this.handleKeyDown, id: htmlId, "data-testid": testId }, rest),
                    _this.renderChildren(classNames),
                    description ?
                        h("span", { className: classNames(prefixCls + "-description") }, description)
                        : null,
                    _this.renderAdditionalAction(classNames))));
        };
        return _this;
    }
    ;
    Item.prototype.isSelected = function () {
        if (typeof this.props.selected === 'boolean') {
            return this.props.selected;
        }
        return this.context.selectedIds.indexOf(this.props.id) !== -1;
    };
    Item.prototype.renderChildren = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, children = _a.children, icon = _a.icon;
        var iconElem = icon ?
            typeof icon === 'string' ?
                h("div", { className: classNames(prefixCls + "-icon"), style: { backgroundImage: "url(\"" + icon + "\")" } })
                : icon
            : null;
        var content = typeof children === 'string'
            ? h("div", { className: classNames(prefixCls + "-text-container") }, children)
            : children;
        return iconElem
            ? h("div", { className: classNames(prefixCls + "-icon-container") },
                iconElem,
                content)
            : content;
    };
    Item.prototype.renderAdditionalAction = function (classNames) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, action = _c.action, actionTriggersDropdownHide = _c.actionTriggersDropdownHide, actionAutoFocus = _c.actionAutoFocus;
        var actionActive = this.state.actionActive;
        if (!action) {
            return null;
        }
        var wrapperClassName = classNames(prefixCls + "-action-wrapper", (_a = {},
            _a[prefixCls + "-action-wrapper-active"] = actionActive,
            _a));
        var actionClassName = classNames(prefixCls + "-action", (_b = {},
            _b[prefixCls + "-action-active"] = actionActive,
            _b));
        return (h(Dropdown.Keep, { className: wrapperClassName, onClick: this.handleActionClick, disabled: actionTriggersDropdownHide },
            h(Dropdown, { dropContent: action, alignment: "right-outer", dropContentClassName: classNames(prefixCls + "-action-content"), visible: actionActive, onVisibleChange: this.handleToggleAction, autoFocus: actionAutoFocus },
                h(Dropdown.Keep, { className: actionClassName }))));
    };
    Item.prototype.componentWillUnmount = function () {
        var selectedItemDoms = this.context.selectedItemDoms;
        var dom = this.domRef.current;
        selectedItemDoms === null || selectedItemDoms === void 0 ? void 0 : selectedItemDoms.delete(dom);
    };
    Item.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Item.contextType = MenuItemContext;
    return Item;
}(React.Component));
export default Item;
Item.defaultProps = {
    prefixCls: 'dui-menu-item',
    id: '',
    onMouseEnter: emptyFn,
    onMouseLeave: emptyFn,
    onClick: emptyFn,
    disabled: false,
    onKeyDown: emptyFn,
    actionTriggersDropdownHide: true,
};
